/* eslint-disable react/prop-types, no-unused-vars */

import { Form, Select, Input } from 'antd';

const SplitColumnForm = ({ config, columns, onChange }) => (
    <Form layout="vertical" initialValues={{ delimiter: ',', ...config }} onValuesChange={(_, values) => onChange(values)}>
        <Form.Item label="Column to Split" name="column" rules={[{ required: true }]}>
            <Select placeholder="Select column" options={columns.map(c => ({ label: c, value: c }))} />
        </Form.Item>
        <Form.Item label="Delimiter" name="delimiter" rules={[{ required: true }]}>
            <Input placeholder="e.g., ," />
        </Form.Item>
    </Form>
);

export default SplitColumnForm;
